<template>
    <div class="">
        <div class="mt-2 flex justify-end items-center text-textOnBkg dark:text-dark.textOnBkg mr-2">
            <MazPicker
                v-model="dRange"
                size="sm"
                pickerPosition="right"
                :label="$t('select_period')"
                :max-date="new Date().toISOString().split('T')[0]"
                double
            />
        </div>

        <section class="sm:ml-24 mt-2 ml-5 mb-10 bg-squares dark:bg-dark.tableBG text-panelsText dark:text-dark.panelsText p-1 px-7 rounded-xl shadow-light dark:shadow-dark">
            <h1 class="m-5 ml-0 font-bold text-xl">{{ $t('sexting_costs_per_creator') }}</h1>

            <span v-if="!loading && sextingCosts.length == 0" class="text-black/80 dark:text-dark.textOnBkg">
                <h2 class="font-bold">{{ $t('no_sexting_costs[0]') }}</h2>
                <div v-html="$t('no_sexting_costs[1]')"></div>
                <button @click="$router.push('sexting')" class="hover:scale-105 transition ease-in-out z-10 bg-growth text-white mt-5 rounded p-1.5 px-5 cursor-pointer">
                    {{ $t('shifts_earnings_link') }} <font-awesome-icon icon="fa-solid fa-arrow-right" />
                </button>
            </span>

            <div class="mt-5 pb-5">
                <div class="bg-gray-100 dark:bg-dark.panels grid grid-cols-6 gap-4 w-full p-3 border border-sepBorder dark:border-dark.sepBorder sm:rounded-t-lg text-left font-semibold text-gray-600 dark:text-dark.textOnBkg">
                    <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ $t('name') }}</div>
                    <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ $t('platform') }}</div>
                    <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ $t('from') }}</div>
                    <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ $t('to') }}</div>
                    <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ $t('team') }}</div>
                    <div>{{ $t('cost') }}</div>
                </div>
                <slot v-if="!loading && sextingCosts.length>0">
                    <div class="w-full grid grid-cols-6 gap-4 p-3 py-4 text-left border border-t-0 border-sepBorder dark:border-dark.sepBorder text-gray-500 dark:text-dark.textOnBkg" v-for="(costs,index) in sextingCosts" :key="index">
                        <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{costs.modelName}}</div>
                        <div class="border-r border-sepBorder dark:border-dark.sepBorder"><img :src="$platformLogo(costs)" :title="costs.platformName" :alt="costs.platformName" class="h-5 mt-1"/></div>
                        <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ costs.timestamp_from??null }}</div>
                        <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ costs.timestamp_to??null }}</div>
                        <div class="border-r border-sepBorder dark:border-dark.sepBorder">{{ costs.teamName }}</div>
                        <div>$ {{parseFloat(costs.sum_cost).toFixed(2)}}</div>
                    </div>
                </slot>
                <div v-else-if="loading" class="w-full col-span-6 grid gap-4 p-3 py-10 text-gray-500 dark:text-dark.textOnBkg border border-sepBorder dark:border-dark.sepBorder rounded-b-lg">
                    <font-awesome-icon icon="fas fa-spinner fa-spin" class="text-2xl mx-auto animate-spin" />
                </div>
            </div>
        </section>

        <section class="sm:ml-24 mx-2 sm:mx-0 mt-4 mb-10 pb-10 bg-squares dark:bg-dark.tableBG text-panelsText dark:text-dark.textOnBkg p-1 px-7 rounded-xl max-w-7xl shadow-light dark:shadow-dark">
            <h1 class="m-5 ml-0 font-bold text-xl">{{ $t('payroll.h_main')}}:</h1>
            <div class="grid grid-cols-2 gap-5 items-center">
                <img :src="payroll_illustration_1" class="w-full rounded-lg mx-auto max-w-xl shadow-light dark:shadow-dark" />
                <div class="mx-auto">
                    <h2 class="font-bold text-xl mb-1">{{ $t('payroll.h5') }}</h2>
                    <p class="max-w-2xl">{{ $t('payroll.p5') }}</p>
                    <br />
                    <h2 class="font-bold text-xl mb-1">{{ $t('payroll.h1') }}</h2>
                    <p class="max-w-2xl">{{ $t('payroll.p1') }}</p>
                </div>
            </div>
            <hr class="w-4/5 border-0 border-t border-sepBorder dark:border-dark.sepBorder my-10 mx-auto" noshade="noshade" />
            <div class="grid grid-cols-2 gap-5 items-center">
                <div class="mx-auto">
                    <h2 class="font-bold text-xl mb-1">{{ $t('payroll.h3') }}</h2>
                    <p class="max-w-2xl">{{ $t('payroll.p3') }}</p>
                    <br />
                    <h2 class="font-bold text-xl mb-1">{{ $t('payroll.h2') }}</h2>
                    <p class="max-w-2xl">{{ $t('payroll.p2') }} <u class="cursor-pointer" @click="$router.push('sextingCosts')">{{ $t('Sexting_costs') }}</u> section</p>
                </div>
                <div><img :src="payroll_illustration_2" class="w-full rounded-lg mx-auto max-w-xl shadow-light dark:shadow-dark" /></div>
            </div>
        </section>
    </div>
</template>

<script setup>
    import payroll_illustration_1 from '@/assets/images/payroll_illustration_1.svg';
    import payroll_illustration_2 from '@/assets/images/payroll_illustration_2.svg';
</script>

<script>
    export default {
        data() {
            return {
                sextingCosts:[],
                sextingCosts: [],
                mounted:false,
                selectedMonth: null,
                selectedGroup: null,
                selectedEmpl: null,
                selectedTeam: null,
                selectedPlatform: null,
                loading: false,
                customPeriod: {
                    dateFrom: new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0') + '-01',
                    timeFrom: {hours: 0, minutes: 0, seconds: 0},
                    dateTo: new Date().toISOString().split('T')[0],
                    timeTo: {hours: 23, minutes: 59, seconds: 59},
                    maxTo: new Date().toISOString().split('T')[0]
                },
                dRange: {start: null, end: null},
                dateFrom: this.$moment().subtract(9, 'days').format('YYYY-MM-DD'),
                dateTo: this.$moment().format('YYYY-MM-DD'),
            }
        },
        computed: {
            authStore() {
                return useAuthStore();
            },
            permissions() {
                return this.authStore.permissions;
            },
        },
        watch: {
            dRange: function (n,o) {
                this.dateFrom = n.start ? n.start : this.dateFrom;
                this.dateTo = n.end ? n.end : this.dateTo;

                if (this.dateFrom && this.dateTo) {
                    this.getSextingCosts();
                }
            }
        },
        methods: {
            updateSelectedMonth(month) {
                this.selectedMonth = month;
            },
            updateSelectedTeam(team) {
                this.selectedTeam = team;
            },
            updateSelectedPlatform(platform) {
                this.selectedPlatform = platform;
            },
            updateSelectedEmpl(empl) {
                this.selectedEmpl = empl;
            },
            updateSelectedModelN(modelN) {
                this.selectedModelN = modelN;
            },
            updateSelectedModel(model) {
                this.selectedModel = model;
            },
            updateSelectedGroupN(groupN) {
                this.selectedGroupN = groupN;
            },
            updateSelectedGroup(group) {
                this.selectedGroup = group;
            },
            xcheckIcon(condition) {
                return condition ? 'fas fa-check' : 'fas fa-xmark';
            },
            markAsPaid(salary_id,salary_index) {
                if (confirm("Mark as paid?")) {
                    this.$axios.patch("finance/", {
                        userToken: this.$cookies.get('userToken'),
                        action:'markAsPaid',
                        salaryID: salary_id,
                        companyID: this.$cookies.get('c_id')
                    }).then((result) => {
                        this.sextingCosts[salary_index].paid = true;
                    }, (error) => {
                        console.log(error);
                    });
                }
            },
            getSextingCosts() {
                this.$axios.get("finance/", {
                    params: {
                        userToken: this.$cookies.get('userToken'),
                        build:'sextingCosts',
                        timestamp_from: this.dateFrom + ' 00:00:00',
                        timestamp_to: this.dateTo + ' 00:00:00',
                        companyID: this.$cookies.get('c_id'),
                        platform: this.selectedPlatform??1
                    }
                }).then((result) => {
                    if (result.status == 200) {
                        this.sextingCosts = result.data;
                    }
                }, (error) => {
                    console.log(error);
                }).finally(() => { this.loading = false; });
            }
        },
        mounted() {
            this.getSextingCosts();
            this.mounted = true;
        }
    }
</script>